const isEmpty = (str) => {
    return str.length === 0 || !str.trim();
}

export default isEmpty